/**
 * Utility function to strip black and white colors from HTML content
 * This allows the theme to handle dark/light mode properly while preserving other colors
 */
export const stripBlackWhiteColors = (htmlContent: string): string => {
  if (!htmlContent) return '';

  // Define patterns for black and white colors in various formats
  const blackWhitePatterns = [
    // Hex colors (black)
    /color:\s*#000000?/gi,
    /color:\s*#000/gi,
    // Hex colors (white)
    /color:\s*#ffffff?/gi,
    /color:\s*#fff/gi,
    // RGB colors (black)
    /color:\s*rgb\(\s*0\s*,\s*0\s*,\s*0\s*\)/gi,
    // RGB colors (white)
    /color:\s*rgb\(\s*255\s*,\s*255\s*,\s*255\s*\)/gi,
    // RGBA colors (black)
    /color:\s*rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*[01]?\.?\d*\s*\)/gi,
    // RGBA colors (white)
    /color:\s*rgba\(\s*255\s*,\s*255\s*,\s*255\s*,\s*[01]?\.?\d*\s*\)/gi,
    // Named colors
    /color:\s*black/gi,
    /color:\s*white/gi,
    // Background colors - same patterns
    /background-color:\s*#000000?/gi,
    /background-color:\s*#000/gi,
    /background-color:\s*#ffffff?/gi,
    /background-color:\s*#fff/gi,
    /background-color:\s*rgb\(\s*0\s*,\s*0\s*,\s*0\s*\)/gi,
    /background-color:\s*rgb\(\s*255\s*,\s*255\s*,\s*255\s*\)/gi,
    /background-color:\s*rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*[01]?\.?\d*\s*\)/gi,
    /background-color:\s*rgba\(\s*255\s*,\s*255\s*,\s*255\s*,\s*[01]?\.?\d*\s*\)/gi,
    /background-color:\s*black/gi,
    /background-color:\s*white/gi,
    // Background shorthand with transparent
    /background-color:\s*transparent/gi
  ];

  let cleanedHtml = htmlContent;

  // Remove each black/white color pattern
  blackWhitePatterns.forEach(pattern => {
    cleanedHtml = cleanedHtml.replace(pattern, '');
  });

  // Clean up any leftover empty style attributes or redundant semicolons
  cleanedHtml = cleanedHtml
    // Remove empty style attributes
    .replace(/style\s*=\s*["'][;\s]*["']/gi, '')
    // Clean up multiple semicolons
    .replace(/;\s*;+/g, ';')
    // Remove leading/trailing semicolons in style attributes
    .replace(/style\s*=\s*["']\s*;/gi, 'style="')
    .replace(/;\s*["']/g, '"');

  return cleanedHtml;
};
